import { styled } from "@mui/material/styles";

const ConfromBoxMain = styled("div")(({ theme }) => ({
  "& button.cancel_button": {
    textAlign: "center",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    border: "1px solid #ccc",
    padding: "4px 15px",
    textTransform: "capitalize",
    fontSize: "16px",
  },
  "& button.confirm_button": {
    textAlign: "center",
    color: "#fff",
    fontFamily: theme.typography.fontFamily,
    textTransform: "capitalize",
    border: "1px solid red",
    padding: "4px 15px",
    backgroundColor: "red",
    marginLeft: "10px",
    fontSize: "16px",
  },
}));

export { ConfromBoxMain };
